var site = site || {};
site.Utilities = (function () {
    function debounce(func, timeout = 100) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, timeout);
        };
    }
    function checkStickyNav() {
        window.addEventListener("scroll", debounce(() => stickyNav()));
    }
    function stickyNav() {
        let nav = document.querySelector('.js-sticky-nav')
        let navHeight = nav.offsetHeight;
        let mainContentOffset = document.querySelector('#main-content').getBoundingClientRect().top * 2;
        if (mainContentOffset <= navHeight) {
            nav.classList.add('nav-stuck');
        } else {
            if (nav.classList.contains('nav-stuck')) {
                nav.classList.remove('nav-stuck');
            }
        }
    }

    function loadWidgetScripts() {
        let scriptsToLoad = [];
        const jsWidget = document.querySelectorAll('[data-scripts]');
        jsWidget.forEach((widget) => {
            const widgetScripts = widget.getAttribute('data-scripts');
            let widgetScriptsArray = widgetScripts.split(",");
            widgetScriptsArray.forEach((src) => {
                let scriptSrcTrimmed = src.trim();
                if (!scriptsToLoad.indexOf(scriptSrcTrimmed) != -1) {
                    scriptsToLoad.push(scriptSrcTrimmed);
                }
            });
        });
        scriptsToLoad.forEach(function (index, value) {
            setTimeout(function () {
                let newScript = document.createElement('script');
                newScript.type = 'text/javascript';
                newScript.src = index;
                // newScript.defer = true;
                document.getElementsByTagName('body')[0].appendChild(newScript);
            }, 250 * value);
        });
    }

    return {
        checkStickyNav: checkStickyNav,
        debounce: debounce,
        loadWidgetScripts: loadWidgetScripts
    };
}());